import api from "app/lib/api";
import endpoints from "static/endpoints";
import { withoutAttrs } from "utils/object";
import { interpolate } from "utils/string";

export const updateClinicNotes = async (
  reportId,
  clinicNotes,
  eSig,
  reportFIN,
  physicianNotes,
  finUpdate
) => {
  let url = `${endpoints.transmissions}/${endpoints.transmission.clinicNotes}`;

  let formattedClinicNotes = clinicNotes;

  if (reportFIN) {
    formattedClinicNotes = `${clinicNotes ?? " "}\n\nFIN: ${reportFIN}`;
  }

  let payload = {
    reportId,
    notes: formattedClinicNotes,
    eSig,
    physicianNotes,
  };

  if (finUpdate || eSig) {
    payload.finUpdate = true;
  }

  if (reportId) {
    const { data } = await api.put(url, payload);

    return data;
  }
};

export const upsertPatientNotes = async (serialNumber, noteList, reportId) => {
  if (serialNumber) {
    const response = await api.put(endpoints.transmission.patientNotes, {
      reportId,
      serialNumber,
      clinicianNotes: noteList,
    });

    return response;
  }
};

export const upsertReportNotes = async (
  reportId,
  billingDate,
  checkBillingDate,
  evokeNotes,
  autoScrollPageNumber,
  isAlertStatusUpdate,
  alertNotifications,
  skipAlertNotification,
  valid,
  displayPopup,
  nonBillable
) => {
  const notes = evokeNotes?.map((note) => {
    const { content, note: noteTitle } = note || {};

    const newContent = content?.map((noteContent) =>
      withoutAttrs(noteContent, ["isDefault"])
    );

    return { note: noteTitle, content: newContent };
  });

  const payload = {
    reportId,
    billingDate,
    checkBillingDate,
    evokeNotes: notes,
    autoScrollPageNumber,
    isAlertStatusUpdate,
    alertNotifications,
    skipAlertNotification,
    valid,
    displayPopup,
    nonBillable,
  };

  if (reportId) {
    const data = await api.put(endpoints.transmission.reportNotes, payload);

    return data;
  }
};

export const updateDiagnosisCodes = async (reportId, billingDiagnosisCodes) => {
  const data = await api.put(endpoints.transmission.diagnosisCodes, {
    reportId,
    billingDiagnosisCodes,
  });

  return data;
};

export const savePatientMRN = async (patientId, patientMRN) => {
  const response = await api.put(endpoints.transmission.patientMRN, {
    patientId,
    mrn: patientMRN,
  });

  return response;
};

export const saveChfScreeningNotes = async (payload) => {
  const url = endpoints.transmission.saveChfScreeningNotes;
  return await api.put(url, payload);
};

export const updateClinicNotesWithQuickText = async (reportId, notes) => {
  let url = interpolate(endpoints.transmission.clinicNoteWithText, {
    reportId,
  });

  if (reportId) {
    return await api.put(url, { note: notes });
  }
};

export const updateProviderNote = async (reportId, notes) => {
  let url = interpolate(endpoints.transmission.providerNote, {
    reportId,
  });

  if (reportId) {
    return await api.put(url, { note: notes });
  }
};

export const addNoteComment = async (payload) => {
  const { reportId, contentId, comment } = payload;

  let url = interpolate(endpoints.transmission.addNoteComment, {
    reportId,
    contentId,
  });

  if (reportId) {
    return await api.post(url, { comment });
  }
};

export const updateNoteComment = async (payload) => {
  const { reportId, contentId, comment, commentId } = payload;

  let url = interpolate(endpoints.transmission.updateNoteComment, {
    reportId,
    contentId,
    commentId,
  });

  if (reportId) {
    return await api.put(url, { comment });
  }
};
